<!--table starts-->

<div class="subheader with-padding flgrow">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-8">
        <div class="relative flmid">
          <div class="input-group flgrow">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearchByCompetencies' | translate }}"
              [(ngModel)]="pService.searchTerm" autocomplete="off" />
              <div class="input-group-append">
                <button type="button" class="btn btn-primary">
                  <em class="fa fa-search"></em>
                </button>
              </div>
          </div>

        </div>

      </div>
      <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
        <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus" 
        (change)="StatusChange($event)">
            <ng-option *ngFor="let status of StatusList" [value]="status.id" >
                  {{status.value}}
            </ng-option>
        </ng-select>
    </div>
      <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
        <button type="button" (click)="onAdd()" type="reset" class="add-button btn btn-primary" aria-label="Center Align"
          translate>lblAddCompetence</button>
      </div>
    </div>
  </div>

  <div class="container prel">
    <div class="row">
      <div class="c12">
        <div class="card mb-3">
          <div class="card-header d-flex" translate>
            lblCompetencies
          </div>
          <div class="table-responsive">


          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th style="width: 30%" scope="col" sortable="name" (sort)="onSort($event)" translate>lblName</th>
                <th style="width: 10%" scope="col" sortable="code" (sort)="onSort($event)" translate>lblCode</th>
                <th style="width: 10%" class="text-center" scope="col" sortable="priority" (sort)="onSort($event)" translate>lblPriority</th>
                <th style="width: 30%" scope="col" translate>lblBrands</th>
                <th style="width: 10%" scope="col" translate class="text-center">lblIsActive</th>
                <th style="width: 120px" class="text-center" scope="col" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="competenceListViewModel?.length>0; else load_else">
                <tr *ngFor="let competence of competenceListViewModel; let i=index">
                  <td>{{ competence.rowNumber }}</td>
                  <td>
                    <ngb-highlight [result]="competence.name" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="competence.code" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td class="text-center">
                    <ngb-highlight [result]="competence.priority" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    
                      <ngb-highlight style="max-width: 300px" class="d-inline-block text-truncate text-truncate--2" [result]="competence.brands" [term]="pService.searchTerm" [ngbTooltip]="tipContent" tooltipClass="long-tooltop"></ngb-highlight>
                    

                    
                      <ng-template #tipContent>
                        <ngb-highlight [result]="competence.brands" [term]="pService.searchTerm"></ngb-highlight>
                      </ng-template>
                    


                  </td>
                  <td class="text-center">
                    <em class="fas" [ngClass]="{'fa-check': competence.isActive, 'fa-close': !competence.isActive}"></em>
                  </td>
                  <td class="nowrap text-center">
                    <a class="btn btn-ico " ngbTooltip="{{ competence.isDefault ? ('lblView' | translate) : ('lblEdit' | translate)}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canEdit"
                        (click)="gotoEdit(competence.id)">
                        <em class="fas fa-pencil-alt fa-lg" *ngIf="!competence.isDefault"></em>
                        <em class="fas fa-eye fa-lg" *ngIf="competence.isDefault"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                    <a class="btn btn-ico"  ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canDelete"
                      (click)="competence.isDefault ? '' : deleteCompetence(competence.id)" [style.opacity]="competence.isDefault ? 0.7 : 1">
                    <em class="far fa-trash-alt fa-lg"></em>
                    </a>


                  </td>

                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="7" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
          </div>
          <div class="card-footer">
            <div class="d-flex justify-content-between">
              <div class="d-flex justify-content-between">
                <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page" [pageSize]="pService.pageSize"
                  [maxSize]="3">
                </ngb-pagination>
                <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                  <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                  </option>
                </select>
              </div>
              <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
                <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
